module.exports = __webpack_public_path__ + "static/menu-illupino-min1-a0c6420844288fe3aacba6b120d56f72.jpg";